export enum ActionRulesType  {
    SET_FIELD_VALUE,
    HIDE_OBJECT,
    SHOW_OBJECT,
    HIDE_FIELD,
    SHOW_FIELD,
    FIELD_REQUIRED,
    FIELD_OPTIONAL,
    FIELD_EDITABLE,
    SET_INPUT_VALUE,
    FIELD_READONLY,
    SET_MENU_FIELD_INCULDE,
    SET_MENU_FIELD_EXCULDE,
    SET_URL_BROWSER_CONTROL,
    OBJECT_READ_ONLY,
    OBJECT_EDITABLE,
    DISPLAY_MESSAGE,
    EDITOR_READ_ONLY,
    SHOW_BEST_ANSWER_DIALOG
}